import React from "react";
import { useForm, FormFieldUploadFile, Button, MainLoader } from "@netapp/bxp-design-system-react";
import styles from "./InstallCertificate.module.scss";
import { useDispatch, useSelector } from "react-redux";
import useErrorContext from "../../../../utils/useErrorContext";
import usePermission from "utils/usePermission";
import { useTranslation } from 'react-i18next';
import { connectorsettings as i18nNamespace } from "../../../../i18n/namespace";

export default React.memo(({ configurationLayout = false }) => {
    const form = useForm({ certificate: null, key: null });
    const loadCertificate = useSelector(state => state.connectorSettings.https.loadCertificate);
    const dispatch = useDispatch();
    const { t } = useTranslation(i18nNamespace);
    const hasPermission = usePermission(["https_setup", "httpsetup"]);
    const createHttpSetup = hasPermission({
        permissionType: "create"
    });
    const tooltip = !createHttpSetup ? t("no_permission_to_create_http_setup") : null;
    const { handleFormSubmit, formState } = form;
    const installCertificate = (e) => {
        e.preventDefault();
        dispatch({
            type: "CONNECTOR-SETTINGS:INSTALL-CA-HTTPS-CERTIFICATE",
            payload: {
                occmCertificate: formState.certificate.contents,
                privateKey: formState.key.contents
            }
        });
    }
    useErrorContext("HTTPS-CA-INSTALL");
    return <>
        {loadCertificate && <MainLoader />}
        <div className={configurationLayout ? styles.configurationBase : styles["base"]}>
            <div className={styles["file-upload"]}>
                <div className={styles["https-inputs"]}>
                    <FormFieldUploadFile className={styles['inputs']} form={form} label={t("certificate")} name="certificate"
                        placeholder={configurationLayout ? t("upload_a_certificate") : t("FileName")} hideText={!configurationLayout} />
                </div>
                <div className={styles["https-inputs"]}>
                    <FormFieldUploadFile className={styles['inputs']} form={form} label={t("private_key")} name="key"
                        placeholder={t("upload_a_file")} hideText={!configurationLayout} />
                </div>
            </div>
            <div className={configurationLayout ? styles.configurationInstall : styles["install"]}>
                <Button tooltip={tooltip} disabled={!(createHttpSetup && formState.certificate && formState.key)}
                    onClick={e => handleFormSubmit(installCertificate)(e)}>{t("install")}</Button>
            </div>
        </div>
    </>
});
